import { render, staticRenderFns } from "./Requisitos.vue?vue&type=template&id=dd31e260&"
import script from "./Requisitos.vue?vue&type=script&lang=ts&"
export * from "./Requisitos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports